<template>

  <v-container fluid class="page page-download-order-invoice">

    <!-- App logo -->
    <transition name="fade-slow" appear>
      <v-row no-gutters>
        <v-col class="pa-0 ma-0 d-flex flex-column align-center justify-center">
          <route-leaf-emblem class="mt-8 mb-0" />
        </v-col>
      </v-row>
    </transition>

    <!-- Page title -->
    <v-row class="mt-6">
      <v-col class="text-h4 mt-4" align="center">
        {{ title }}
      </v-col>
    </v-row>

    <!-- Order info -->
    <v-row>
      <v-col class="mt-2" align="center">
        ({{ orderId }})
      </v-col>
    </v-row>

    <template v-if="invoiceUrl">
      <v-row>
        <v-col class="mt-3" align="center">
          <div style="font-size:1.3rem;">The document is downloading.</div>
          <div style="font-style:italic;" class="mt-2">Use the link below if the download does not complete.</div>
        </v-col>
      </v-row>

      <!-- Download link -->
      <v-row>
        <v-col class="mt-4" align="center">
          <v-icon class="mr-1 icon-download" color="primary">mdi-download</v-icon>
          <a :href="invoiceUrl" ref="download-link" class="download-link" title="Download Invoice">Download Invoice</a>
        </v-col>
      </v-row>
    </template>

  </v-container>

</template>

<script>
import RouteLeafEmblem from '@/components/app/RouteLeafEmblem'

const downloadApiBaseUrl = process.env.VUE_APP_DOWNLOAD_API_BASE_URL

export default {
  name: 'DownloadOrderInvoicePage',

  components: {
    RouteLeafEmblem
  },

  props: {
    orderId: {
      type: String,
      default: null
    }
  },

  computed: {
    title () {
      const orderNumber = this.$route.query.order_number
      return (orderNumber) ? `Download Invoice - ${orderNumber}` : 'Download Invoice'
    },
    invoiceUrl () {
      return (downloadApiBaseUrl)
        ? `${downloadApiBaseUrl}/download/order/${this.orderId}/invoice`
        : null
    }
  },

  mounted () {
    const link = this.$refs['download-link']
    if (link) link.click()
  },

  methods: {
    performDownload () {
      // TODO - Run through sh/dataApi !!!
    }
  }
}
</script>

<style scoped>
  a.download-link {
    text-decoration: none;
  }

  a.download-link:hover {
    text-decoration: underline;
  }
</style>
